import { render, staticRenderFns } from "./PlatformModal.vue?vue&type=template&id=3f67c387&scoped=true&"
import script from "./PlatformModal.vue?vue&type=script&lang=js&"
export * from "./PlatformModal.vue?vue&type=script&lang=js&"
import style0 from "./PlatformModal.vue?vue&type=style&index=0&id=3f67c387&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f67c387",
  null
  
)

export default component.exports